import { render, staticRenderFns } from "./SideMenuBigApp.vue?vue&type=template&id=6cce20ab&"
import script from "./SideMenuBigApp.vue?vue&type=script&lang=js&"
export * from "./SideMenuBigApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports